// extracted by mini-css-extract-plugin
export default {"rippleContainer":"index_rippleContainer__pXVba","rippleDot":"index_rippleDot__iAY15","rippleFadeScale":"index_rippleFadeScale__-o6pa"};